import { Article } from "@r8er/components/marketing/article";
import { Content } from "@r8er/components/marketing/content";
import { Hero } from "@r8er/components/marketing/hero";
import { Layout } from "@r8er/components/marketing/layout";
import { Newsletter } from "@r8er/components/marketing/newsletter";
import { getAllArticles, getSingleArticleBySlug } from "@r8er/lib/cms";
import Head from "next/head";

export default function ArticlePage({ article }) {
  return (
    <div>
      <Head>
        <title>{`${article.title} - R8ER`}</title>
        <link rel="icon" href="/favicon.png" />
      </Head>

      <Layout>
        <Hero isTiny isWide isCentered title={article.title}>
          <div
            style={{
              textAlign: "center",
            }}
          >
            Posted by {article.authors.map((author) => author.name).join(", ")}{" "}
            on {new Date(article.published_at).toLocaleDateString()}
          </div>
        </Hero>
        <Content isFullWidth>
          <Article article={article} />
        </Content>
        <Newsletter hasBlueDivider />
      </Layout>
    </div>
  );
}

export async function getStaticPaths() {
  const articles = await getAllArticles();

  const articlePaths = articles.map((article) => ({
    params: { slug: article.slug },
  }));

  return {
    paths: articlePaths,
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const article = await getSingleArticleBySlug(params.slug);

  return {
    props: { article },
  };
}
